import { useEffect, useRef, useState } from 'react';

const S = {
  page:      { padding:'28px 24px', maxWidth:1200, margin:'0 auto', fontFamily:'Poppins, sans-serif' },
  header:    { display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginBottom:24 },
  h1:        { fontSize:'1.6rem', fontWeight:800, color:'#1a1a2e', display:'flex', alignItems:'center', gap:10, margin:0 },
  searchWrap:{ position:'relative', minWidth:260 },
  searchIn:  { width:'100%', padding:'9px 38px 9px 14px', border:'1.5px solid #e2e8f0', borderRadius:10,
               fontFamily:'Poppins, sans-serif', fontSize:'0.9rem', outline:'none', background:'#f8fafc', color:'#1a2a4a' },
  table:     { width:'100%', background:'#fff', borderRadius:16, boxShadow:'0 4px 20px rgba(0,0,0,0.07)', overflow:'hidden', minWidth:800 },
  th:        { padding:'12px 14px', textAlign:'left', background:'#1a2a4a', color:'#fff', fontWeight:700, fontSize:'0.82rem',
               textTransform:'uppercase', letterSpacing:'0.4px', whiteSpace:'nowrap' },
  td:        { padding:'12px 14px', fontSize:'0.88rem', color:'#334155', borderBottom:'1px solid #f1f5f9', verticalAlign:'middle' },
  toast:     { position:'fixed', bottom:90, right:24, padding:'11px 22px', borderRadius:10, color:'#fff',
               fontSize:'0.88rem', fontWeight:600, zIndex:9999, boxShadow:'0 4px 16px rgba(0,0,0,0.15)',
               fontFamily:'Poppins, sans-serif' },
};

function Badge({ children, color, bg }) {
  return (
    <span style={{ padding:'3px 10px', borderRadius:20, background:bg, color, fontSize:'0.75rem', fontWeight:700, whiteSpace:'nowrap' }}>
      {children}
    </span>
  );
}

export default function AdminUsers() {
  const [users,   setUsers]   = useState([]);
  const [search,  setSearch]  = useState('');
  const [loading, setLoading] = useState(true);
  const [toast,   setToast]   = useState(null);
  const [toggling, setToggling] = useState({});
  const toastTimer = useRef(null);

  function showToast(msg, type = 'success') {
    setToast({ msg, type });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  }

  async function loadUsers() {
    setLoading(true);
    try {
      const res = await fetch('/admin/users-json', { credentials: 'include' });
      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch { showToast('Erro ao carregar usuários.', 'error'); }
    finally { setLoading(false); }
  }

  useEffect(() => { loadUsers(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function toggleStudent(userId, currentIsAluno) {
    setToggling(p => ({ ...p, [userId]: true }));
    try {
      const res = await fetch('/admin/toggle-student', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ userId }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Erro');
      setUsers(prev => prev.map(u => u.id === userId ? { ...u, isAluno: currentIsAluno ? 0 : 1 } : u));
      showToast(data.message || 'Status atualizado!');
    } catch (e) { showToast(e.message, 'error'); }
    finally { setToggling(p => ({ ...p, [userId]: false })); }
  }

  const filtered = users.filter(u =>
    !search || [u.nome, u.email].join(' ').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={S.page}>
      <div style={S.header}>
        <h1 style={S.h1}>
          <i className="fas fa-users-cog" style={{ color:'#1e90ff' }} />
          Gerenciar Usuários
          <span style={{ fontSize:'0.85rem', color:'#94a3b8', fontWeight:400 }}>({users.length})</span>
        </h1>

        <div style={S.searchWrap}>
          <input
            style={S.searchIn}
            placeholder="Buscar por nome ou email..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <i className="fas fa-search" style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', color:'#94a3b8', fontSize:'0.85rem' }} />
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:'60px 0', color:'#94a3b8' }}>
          <i className="fas fa-spinner fa-spin fa-2x" />
        </div>
      ) : (
        <div style={{ overflowX:'auto' }}>
          <table style={S.table}>
            <thead>
              <tr>
                {['Nome','Email','Tipo','Aluno','Assinatura','Plano','Expiração','Ação'].map(h => (
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(u => (
                <tr key={u.id}>
                  <td style={S.td}><strong style={{ color:'#1a2a4a' }}>{u.nome}</strong></td>
                  <td style={S.td}><span style={{ color:'#64748b' }}>{u.email}</span></td>
                  <td style={{ ...S.td, textAlign:'center' }}>
                    {u.isAdmin
                      ? <Badge color="#1565c0" bg="#dbeafe">Admin</Badge>
                      : <Badge color="#92400e" bg="#fef3c7">Usuário</Badge>}
                  </td>
                  <td style={{ ...S.td, textAlign:'center' }}>
                    {u.isAluno
                      ? <Badge color="#065f46" bg="#d1fae5">Ativo</Badge>
                      : <Badge color="#991b1b" bg="#fee2e2">Inativo</Badge>}
                  </td>
                  <td style={{ ...S.td, textAlign:'center' }}>
                    {u.assinatura
                      ? u.assinatura.isAtiva
                        ? <Badge color="#0369a1" bg="#e0f2fe">Ativa</Badge>
                        : <Badge color="#9f1239" bg="#fce7f3">Expirada</Badge>
                      : <Badge color="#475569" bg="#f1f5f9">Nenhuma</Badge>}
                  </td>
                  <td style={{ ...S.td, textAlign:'center', color:'#64748b' }}>
                    {u.assinatura?.plano || '—'}
                  </td>
                  <td style={{ ...S.td, textAlign:'center', color:'#64748b', whiteSpace:'nowrap' }}>
                    {u.assinatura?.dataExpiracao || '—'}
                  </td>
                  <td style={{ ...S.td, textAlign:'center' }}>
                    {!u.isAdmin && (
                      <button
                        disabled={toggling[u.id]}
                        onClick={() => toggleStudent(u.id, u.isAluno)}
                        style={{
                          padding:'7px 14px', border:'none', borderRadius:8, cursor:'pointer',
                          fontFamily:'Poppins, sans-serif', fontSize:'0.8rem', fontWeight:700,
                          background: u.isAluno ? '#f97316' : '#10b981',
                          color:'#fff', opacity: toggling[u.id] ? 0.6 : 1,
                          transition:'opacity 0.2s',
                        }}
                      >
                        {toggling[u.id]
                          ? <i className="fas fa-spinner fa-spin" />
                          : u.isAluno ? 'Desativar' : 'Ativar'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={8} style={{ ...S.td, textAlign:'center', color:'#94a3b8', padding:'32px' }}>
                  Nenhum usuário encontrado.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {toast && (
        <div style={{ ...S.toast, background: toast.type === 'success' ? '#059669' : '#dc2626' }}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
